import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PlatformServices from "../based/services/PlatformServices";
import TFUSelect from "../based/inputs/TFUSelect";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";
import CommonModal from "../based/Modal";
import CloseIcon from "./assets/CloseIcon.svg";

function PlatformBrandModal({ show, onClose, shopId, platform, onSave }) {
    const [brandOptions, setBrandOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState("");

    useEffect(() => {
        if (shopId) getBrands(shopId);
    }, [shopId]);

    const getBrands = async (shopId) => {
        const [err, data] = await PlatformServices.GetBrands(shopId);
        if (!err && data) {
            setBrandOptions(data);
        } else {
            setBrandOptions([]);
        }
    };

    const handleSave = async () => {
        const selectItem = brandOptions.find((item) => item.value == selectedValue);
        const [err, data] = await PlatformServices.CreateUpdatePlatformBrand({
            shopId: shopId,
            platform: platform,
            brandId: selectedValue,
            brandName: selectItem ? selectItem.label : "",
            isDefault: false,
        });
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Thêm thương hiệu thành công");
            onSave();
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Thêm thương hiệu thất bại");
        }
    };

    return (
        <CommonModal show={show} onClose={onClose} size={"md"} hiddenFooter hideClose>
            <Wrapper>
                <section className="header">
                    <div className="center-item">Thêm thương hiệu Tiktok</div>
                    <div className="close-button">
                        <button type="button" className="btn-close-custom" onClick={onClose}>
                            <img src={CloseIcon} alt="" />
                        </button>
                    </div>
                </section>
                <section className="body">
                    <div className="form-group">
                        <label htmlFor="" className="required">
                            Chọn thương hiệu đã đăng ký
                        </label>
                        <TFUSelect options={brandOptions} value={selectedValue} onChanged={(value) => setSelectedValue(value)} placeholder="Chọn thương hiệu" />
                    </div>
                    <div className="form-intruction">
                        <p>
                            Bước 1: Đăng kí thương hiệu trên Shopee
                            <span
                                className="highlight"
                                onClick={(e) => {
                                    window.open("https://banhang.shopee.vn/edu/article/16090", "_blank");
                                }}
                            >
                                Hướng dẫn <i className="fa fa-chevron-right"></i>
                            </span>
                            <br />
                            {"Bước 2: Sau khi Tiktok đã duyệt thương hiệu, vào “Cài đặt kênh bán hàng”  >  “Thêm Thương hiệu”  >  “Chọn thương hiệu”  >  “Hoàn thành”"}
                        </p>
                    </div>
                </section>
                <section className="bottom">
                    <div className="list-action">
                        <button
                            className="btn btn-secondary"
                            onClick={(e) => {
                                onClose();
                            }}
                        >
                            Đóng
                        </button>
                        <button
                            className="btn btn-orange"
                            onClick={(e) => {
                                handleSave();
                            }}
                        >
                            Hoàn thành
                        </button>
                    </div>
                </section>
            </Wrapper>
        </CommonModal>
    );
}

export default PlatformBrandModal;

const Wrapper = styled.div`
    section.header {
        background: #ff9027;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
    }

    .close-button {
        margin: 0 30px 0 auto;
    }

    .center-item {
        margin-left: auto;
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 100% */
    }

    .close-button button.btn-close-custom {
        border: none;
        background: none;
        color: white;
    }

    section.body {
        padding: 24px;
    }

    span.highlight {
        color: #ff9027;
        margin-left: 6px;
    }

    .form-intruction p {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .form-intruction {
        margin: 10px 0;
    }

    section.bottom {
        border: 1px solid #f3f3f3;
        background: #fff;
        box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.1);
        padding: 12px;
    }

    .list-action {
        display: flex;
        justify-content: center;
    }

    .list-action button.btn.btn-secondary {
        border-radius: 40px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        color: #000;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        padding: 6px;
        margin: 0 10px;
        width: 120px;
    }

    .list-action button.btn.btn-orange {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        padding: 6px;
        width: 120px;
    }
`;
